import { Outlet } from 'react-router-dom';

import { useIdlePrefetch } from 'Helpers/hooks/useIdlePrefetch.ts';

import { AuthUserTypeSelect, SignIn, SignUp } from './lazyAuthPages.ts';

// Signing up means walking through three chunks in one sitting, so whichever of them loads
// first warms the rest. The layout route outlives the pages under it and prefetches once for
// the whole flow.
export function AuthWrapper() {
    useIdlePrefetch(preloadAuthPages);

    return <Outlet />;
}

function preloadAuthPages() {
    SignIn.preload();
    AuthUserTypeSelect.preload();
    SignUp.preload();
}
